import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import VisitedGlobe from '../src/VisitedGlobe';
import LoginPage from './LoginPage';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.REACT_APP_BACKEND_URL;

function App() {
    const [user, setUser] = useState(null);
    const [authChecked, setAuthChecked] = useState(false);
    const [userNotAllowed, setUserNotAllowed] = useState(false);

    console.log("BACKEND_URL: " + BACKEND_URL);

    useEffect(() => {
        const token = localStorage.getItem('token') || new URLSearchParams(window.location.search).get('token');

        if (token) {
            localStorage.setItem('token', token); // Save for later use
            fetch(`${BACKEND_URL}/auth/me`, {
                headers: { Authorization: `Bearer ${token}` }
            })
                .then(res => res.json())
                .then(data => {
                    const allowedEmails = (
                        process.env.REACT_APP_ALLOWED_EMAILS || window.REACT_APP_ALLOWED_EMAILS || ''
                    ).split(',').map(email => email.trim());
                    if (allowedEmails.includes(data.email)) {
                        setUser(data);
                    } else {
                        setUserNotAllowed(true);
                        localStorage.removeItem('token');
                    }
                })
                .catch(err => {
                    console.error("Failed to get user:", err);
                    localStorage.removeItem('token');
                })
                .finally(() => {
                    setAuthChecked(true);
                });
        } else {
            setAuthChecked(true);
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        setUser(null);
    };

    //console.log("user: " + JSON.stringify(user, null, 2));
    if (!user) {
        return <LoginPage userNotAllowed={userNotAllowed} />;
    }

    return (
        <div>
            <button onClick={handleLogout} style={{ position: "absolute", top: 10, right: 10 }}>
                Logout
            </button>
            <Router>
                <Routes>
                    <Route path="/" element={<VisitedGlobe user={user} />} />
                </Routes>
            </Router>
        </div>
    );
}

export default App;